import { formatNegativeYValue, formatPercent, formatPositiveYValue } from '../utils'

export const positiveSparklineOptions = {
  axis: { strokeWidth: 0 },
  formatter: formatPositiveYValue,
  label: {
    color: 'white',
    enabled: true,
    fontSize: 11,
    fontWeight: 'bold',
    formatter: formatPercent,
  },
  padding: { bottom: 0, top: 0 },
  paddingOuter: 0,
  tooltip: { enabled: false },
  type: 'bar',
  valueAxisDomain: [0, 1],
}

export const negativeSparklineOptions = {
  axis: { strokeWidth: 0 },
  formatter: formatNegativeYValue,
  label: {
    color: 'white',
    enabled: true,
    fontSize: 11,
    fontWeight: 'bold',
    formatter: formatPercent,
  },
  padding: { bottom: 0, top: 0 },
  paddingOuter: 0,
  tooltip: { enabled: false },
  type: 'bar',
  valueAxisDomain: [0, 1],
}

export const fieldsWithNumberValueFormatter = [
  // global
  'installs_quantity',
  'extrapolation',

  // mwm-nb-users
  'mwm_nbu_free_trial_d0',
  'mwm_nbu_free_trial_d10',
  'mwm_nbu_free_trial_lifetime',
  'mwm_nbu_subscriber_d0',
  'mwm_nbu_subscriber_d10',
  'mwm_nbu_subscriber_lifetime',
  'mwm_nbu_paying_user_d0',
  'mwm_nbu_paying_user_d10',
  'mwm_nbu_paying_user_lifetime',

  // network
  'impressions',
  'clicks',

  // unknonwn
  'max_dai',
]

export const fieldsWithMoneyFormatter = [
  // arpu-ads-predictions-euro
  'ua_arpu_ads_pred_d0_360_eur',
  'ua_arpu_ads_pred_d10_360_eur',
  'ua_arpu_ads_pred_d20_360_eur',
  'ua_arpu_ads_pred_d3_360_eur',
  'ua_arpu_ads_pred_d30_360_eur',
  'ua_arpu_ads_pred_d40_360_eur',
  'ua_arpu_ads_pred_d7_360_eur',

  // arpu-predictions-euro
  'ua_arpu_pred_d0_360_eur',
  'ua_arpu_pred_d3_360_eur',
  'ua_arpu_pred_d7_360_eur',
  'ua_arpu_pred_d10_360_eur',
  'ua_arpu_pred_d20_360_eur',
  'ua_arpu_pred_d30_360_eur',
  'ua_arpu_pred_d40_360_eur',

  // arpu-subscriptions-predictions-euro
  'ua_arpu_inapps_pred_d0_360_eur',
  'ua_arpu_inapps_pred_d3_360_eur',
  'ua_arpu_inapps_pred_d7_360_eur',
  'ua_arpu_inapps_pred_d10_360_eur',
  'ua_arpu_inapps_pred_d20_360_eur',
  'ua_arpu_inapps_pred_d30_360_eur',
  'ua_arpu_inapps_pred_d40_360_eur',

  // global
  'total_spent',
  'cpi',

  // mwm-ads-arpu
  'mwm_ads_revenue_per_install_d0_eur',
  'mwm_ads_revenue_per_install_d1_eur',
  'mwm_ads_revenue_per_install_d3_eur',
  'mwm_ads_revenue_per_install_d7_eur',
  'mwm_ads_revenue_per_install_d10_eur',
  'mwm_ads_revenue_per_install_d30_eur',
  'mwm_ads_revenue_per_install_d180_eur',
  'mwm_ads_revenue_per_install_d360_eur',
  'mwm_ads_revenue_per_install_total_eur',

  // mwm-ads-eltv
  'mwm_total_ads_pred_d30_360_eur',
  'mwm_total_ads_pred_d10_360_eur',
  'mwm_total_ads_pred_d7_360_eur',
  'mwm_total_ads_pred_d3_360_eur',
  'mwm_total_ads_pred_d0_360_eur',

  // mwm-ads-revenue-euro
  'mwm_ads_revenue_total_eur',
  'mwm_ads_revenue_d0_eur',
  'mwm_ads_revenue_d1_eur',
  'mwm_ads_revenue_d3_eur',
  'mwm_ads_revenue_d7_eur',
  'mwm_ads_revenue_d30_eur',
  'mwm_ads_revenue_d180_eur',
  'mwm_ads_revenue_d360_eur',

  // mwm-arpu
  'mwm_arpu_d0',
  'mwm_arpu_d1',
  'mwm_arpu_d3',
  'mwm_arpu_d7',
  'mwm_arpu_d10',
  'mwm_arpu_d30',
  'mwm_arpu_d180',
  'mwm_arpu_d360',
  'mwm_arpu',

  // mwm-cost-per-user
  'mwm_cost_per_free_trial_d0',
  'mwm_cost_per_free_trial_d10',
  'mwm_cost_per_free_trial_lifetime',
  'mwm_cost_per_subscriber_d0',
  'mwm_cost_per_subscriber_d10',
  'mwm_cost_per_subscriber_lifetime',
  'mwm_cost_per_paying_user_d0',
  'mwm_cost_per_paying_user_d10',
  'mwm_cost_per_paying_user_lifetime',

  // mwm-eltv
  'mwm_total_pred_d30_360_eur',
  'mwm_total_pred_d10_360_eur',
  'mwm_total_pred_d7_360_eur',
  'mwm_total_pred_d3_360_eur',
  'mwm_total_pred_d0_360_eur',

  // mwm-iap-arpu
  'mwm_inapps_revenue_per_install_d0_eur',
  'mwm_inapps_revenue_per_install_d1_eur',
  'mwm_inapps_revenue_per_install_d3_eur',
  'mwm_inapps_revenue_per_install_d7_eur',
  'mwm_inapps_revenue_per_install_d10_eur',
  'mwm_inapps_revenue_per_install_d30_eur',
  'mwm_inapps_revenue_per_install_d180_eur',
  'mwm_inapps_revenue_per_install_d360_eur',
  'mwm_inapps_revenue_per_install_total_eur',

  // mwm-iap-eltv
  'mwm_total_inapps_pred_d30_360_eur',
  'mwm_total_inapps_pred_d10_360_eur',
  'mwm_total_inapps_pred_d7_360_eur',
  'mwm_total_inapps_pred_d3_360_eur',
  'mwm_total_inapps_pred_d0_360_eur',

  // mwm-inapps-revenue-euro
  'mwm_inapps_revenue_total_eur',
  'mwm_inapps_revenue_d0_eur',
  'mwm_inapps_revenue_d1_eur',
  'mwm_inapps_revenue_d3_eur',
  'mwm_inapps_revenue_d7_eur',
  'mwm_inapps_revenue_d30_eur',
  'mwm_inapps_revenue_d180_eur',
  'mwm_inapps_revenue_d360_eur',

  // mwm-revenue-per-user
  'mwm_revenue_per_free_trial_lifetime',
  'mwm_eltv_d10_per_freetrial_lifetime',
  'mwm_revenue_per_subscriber_lifetime',
  'mwm_eltv_d10_per_subscriber_lifetime',
  'mwm_revenue_per_paying_user_lifetime',
  'mwm_eltv_d10_per_paying_lifetime',

  // mwm-total-ads-predictions-euro
  'mwm_total_ads_pred_d0_360_eur',
  'mwm_total_ads_pred_d3_360_eur',
  'mwm_total_ads_pred_d7_360_eur',
  'mwm_total_ads_pred_d10_360_eur',
  'mwm_total_ads_pred_d20_360_eur',
  'mwm_total_ads_pred_d30_360_eur',
  'mwm_total_ads_pred_d40_360_eur',

  // mwm-total-subscriptions-predictions-euro
  'mwm_total_inapps_pred_d0_360_eur',
  'mwm_total_inapps_pred_d3_360_eur',
  'mwm_total_inapps_pred_d7_360_eur',
  'mwm_total_inapps_pred_d10_360_eur',
  'mwm_total_inapps_pred_d20_360_eur',
  'mwm_total_inapps_pred_d30_360_eur',
  'mwm_total_inapps_pred_d40_360_eur',

  // network
  'cpm',

  // roi
  'mwm_roi_eur',
  'ua_roi_eur',

  // ua-ads-eltv
  'ua_ads_eltv_d30',
  'ua_ads_eltv_d10',
  'ua_ads_eltv_d7',
  'ua_ads_eltv_d3',
  'ua_ads_eltv_d0',

  // ua-ads-revenue-euro
  'ua_ads_revenue_total_eur',
  'ua_ads_revenue_d0_eur',
  'ua_ads_revenue_d1_eur',
  'ua_ads_revenue_d3_eur',
  'ua_ads_revenue_d7_eur',
  'ua_ads_revenue_d30_eur',
  'ua_ads_revenue_d180_eur',
  'ua_ads_revenue_d360_eur',

  // ua-eltv-error-margin-euro
  'ua_eltv_d0_error_margin',
  'ua_eltv_d3_error_margin',
  'ua_eltv_d7_error_margin',
  'ua_eltv_d10_error_margin',
  'ua_eltv_d20_error_margin',
  'ua_eltv_d30_error_margin',
  'ua_eltv_d40_error_margin',

  // ua-eltv
  'ua_eltv_d30',
  'ua_eltv_d10',
  'ua_eltv_d7',
  'ua_eltv_d3',
  'ua_eltv_d0',

  // ua-eroi-euro
  'ua_eroi_eur_d30',
  'ua_eroi_eur_d10',
  'ua_eroi_eur_d7',
  'ua_eroi_eur_d3',
  'ua_eroi_eur_d0',

  // ua-iap-eltv
  'ua_iap_eltv_d30',
  'ua_iap_eltv_d10',
  'ua_iap_eltv_d7',
  'ua_iap_eltv_d3',
  'ua_iap_eltv_d0',

  // ua-inapps-revenue-euro
  'ua_inapps_revenue_total_eur',
  'ua_inapps_revenue_d0_eur',
  'ua_inapps_revenue_d1_eur',
  'ua_inapps_revenue_d3_eur',
  'ua_inapps_revenue_d7_eur',
  'ua_inapps_revenue_d30_eur',
  'ua_inapps_revenue_d180_eur',
  'ua_inapps_revenue_d360_eur',

  // ua-total-ads-predictions-euro
  'ua_total_ads_pred_d0_360_eur',
  'ua_total_ads_pred_d3_360_eur',
  'ua_total_ads_pred_d7_360_eur',
  'ua_total_ads_pred_d10_360_eur',
  'ua_total_ads_pred_d20_360_eur',
  'ua_total_ads_pred_d30_360_eur',
  'ua_total_ads_pred_d40_360_eur',

  // ua-total-predictions-euro
  'ua_total_pred_d0_360_eur',
  'ua_total_pred_d3_360_eur',
  'ua_total_pred_d7_360_eur',
  'ua_total_pred_d10_360_eur',
  'ua_total_pred_d20_360_eur',
  'ua_total_pred_d30_360_eur',
  'ua_total_pred_d40_360_eur',
  'ua_total_pred_dmax_360_eur',

  // ua-total-subscriptions-predictions-euro
  'ua_total_inapps_pred_d0_360_eur',
  'ua_total_inapps_pred_d3_360_eur',
  'ua_total_inapps_pred_d7_360_eur',
  'ua_total_inapps_pred_d10_360_eur',
  'ua_total_inapps_pred_d20_360_eur',
  'ua_total_inapps_pred_d30_360_eur',
  'ua_total_inapps_pred_d40_360_eur',
]

export const fieldsWithPercentValueFormatter = [
  // hints
  'breakeven_probability',
  'margin_minus_10_probability',
  'margin_10_probability',
  'margin_25_probability',

  // mwm-data-per-install
  'mwm_free_trial_per_install_d0',
  'mwm_free_trial_per_install_d10',
  'mwm_free_trial_per_install_lifetime',
  'mwm_subscriber_per_install_d0',
  'mwm_subscriber_per_install_d10',
  'mwm_subscriber_per_install_lifetime',
  'mwm_paying_user_per_install_d0',
  'mwm_paying_user_per_install_d10',
  'mwm_paying_user_per_install_lifetime',

  // mwm-retention
  'mwm_nbu_onboarding_completed',
  'retention_d1',
  'retention_d3',
  'retention_d7',
  'retention_d30',

  // mwm-roi-percent
  'mwm_roi_percent_d30',
  'mwm_roi_percent_d20',
  'mwm_roi_percent_d10',
  'mwm_roi_percent_d7',
  'mwm_roi_percent_d3',
  'mwm_roi_percent_d0',

  // network
  'cvr',
  'ctr',

  // roi
  'mwm_roi_percent',
  'ua_roi_percent',

  // ua-eltv-error-percent
  'ua_eltv_d0_error_rate',
  'ua_eltv_d3_error_rate',
  'ua_eltv_d7_error_rate',
  'ua_eltv_d10_error_rate',
  'ua_eltv_d20_error_rate',
  'ua_eltv_d30_error_rate',
  'ua_eltv_d40_error_rate',

  // ua-eroi-percent
  'ua_eroi_percent_d30',
  'ua_eroi_percent_d10',
  'ua_eroi_percent_d7',
  'ua_eroi_percent_d3',
  'ua_eroi_percent_d0',

  // ua-iap-eltv-sov
  'ua_iap_eltv_sov_d30',
  'ua_iap_eltv_sov_d10',
  'ua_iap_eltv_sov_d7',
  'ua_iap_eltv_sov_d3',
  'ua_iap_eltv_sov_d0',

  // ua-roi-percent
  'ua_roi_percent_d30',
  'ua_roi_percent_d20',
  'ua_roi_percent_d10',
  'ua_roi_percent_d7',
  'ua_roi_percent_d3',
  'ua_roi_percent_d0',

  // unknown
  'retention_d180',
  'retention_d360',
  'ua_eroi_percent_d20',
  'ua_eroi_percent_d40',
]

export const fieldsWithSparklinePositiveValueFormatter = [
  'breakeven_probability',
  'margin_10_probability',
  'margin_25_probability',
]

export const fieldsWithSparklineNegativeValueFormatter = ['margin_minus_10_probability']
